import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    taxs: [],
    isTaxsLoading: false,
    activetaxs: []

}


export const getTaxs = createAsyncThunk(
    'get_taxs_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getTaxsStart());
            const response = await axios.get(`/tax/get_tax.php`)
            console.log('respponse of taxs', response?.data)
            if (response?.data?.status == 'success') {

                dispatch(getTaxsSuccess(response?.data?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getTaxsFailure(error.response.data.message))
        }
    }
)
export const getActiveTaxs = createAsyncThunk(
    'get_active_taxs_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getActiveTaxsStart());
            const response = await axios.get(`/tax/get_active_tax.php`)
            if (response?.status == 200) {
                dispatch(getActiveTaxsSuccess(response?.data))
            }
            return response?.data

        } catch (error) {
            dispatch(getActiveTaxsFailure(error.response.data.message))
        }
    }
)
export const addTax = createAsyncThunk(
    "addtaxs",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            dispatch(addTaxsStart());
            const response = await axios.post(`/tax/add_tax.php`, data);
            dispatch(addTaxsSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getTaxs())
            }
            return response.data
        } catch (error) {
            dispatch(addTaxsFailure(error.response.data.message));
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteTax = createAsyncThunk('deletetax', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateTaxsStart());
        const response = await axios.delete(`/tax/delete_taxs.php?id=${id}`);
        if (response?.data?.status == 'success') {
            dispatch(getTaxs())
        }
        return response.data
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updateTax = createAsyncThunk(
    "hsn/updateHsn",
    async ({ id, data }, { dispatch, rejectWithValue }) => {

        try {
            dispatch(updateTaxsStart());

            // Send to API as expected (id + payload)
            const response = await axios.post(`/tax/update_tax.php`, {
                id,
                ...data,
            });

            if (response?.data?.status === "success") {
                dispatch(updateTaxsSuccess(response.data?.hsn));
                dispatch(getTaxs()); // refresh list
            } else {
                dispatch(updateTaxsFailure(response.data.message));
                return rejectWithValue(response.data.message);
            }

            return response.data;
        } catch (error) {
            const msg = error?.response?.data?.message || "Failed to update tax";
            dispatch(updateTaxsFailure(msg));
            return rejectWithValue(msg);
        }
    }
);

const taxsSlice = createSlice({
    name: 'taxs',
    initialState,
    reducers: {
        getTaxsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getTaxsSuccess(state, action) {
            state.taxs = action.payload;
            state.isLoading = false;
        },
        getTaxsFailure(state, action) {
            state.taxs = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        getActiveTaxsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getActiveTaxsSuccess(state, action) {
            state.activetaxs = action.payload;
            state.isLoading = false;
        },
        getActiveTaxsFailure(state, action) {
            state.activetaxs = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addTaxsStart(state) {
            state.isTaxsLoading = true;
            state.error = null;
        },
        addTaxsSuccess(state, action) {
            state.user = action.payload;
            state.isTaxsLoading = false;
        },
        addTaxsFailure(state, action) {
            state.error = action.payload;
            state.isTaxsLoading = false;
        },

        updateTaxsStart(state) {
            state.isTaxsLoading = true;
            state.error = null;
        },
        updateTaxsSuccess(state, action) {
            state.user = action.payload;
            state.isTaxsLoading = false;
        },
        updateTaxsFailure(state, action) {
            state.error = action.payload;
            state.isTaxsLoading = false;
        },
    }
})

export const { getTaxsSuccess, getTaxsStart, getTaxsFailure, getActiveTaxsSuccess, getActiveTaxsStart, getActiveTaxsFailure, addTaxsStart, addTaxsSuccess, addTaxsFailure, updateTaxsStart, updateTaxsSuccess, updateTaxsFailure } = taxsSlice.actions;

export default taxsSlice.reducer;